import type { IconType } from "../types";
import useBreakpoints from "../useBreakpoints";
import Box from "./Box";
import WelcomeFeaturesListItem from "./WelcomeFeaturesListItem";

export type FeatureProp = {
	icon: IconType;
	title: string;
	subtitle: string;
};

type Props = {
	valueProps: FeatureProp[];
};

const FeatureList = ({ valueProps }: Props) => {
	const { smUp } = useBreakpoints();

	return (
		<Box flexDirection={smUp ? "row" : "column"} gap={24}>
			{valueProps.map((prop, index) => (
				<WelcomeFeaturesListItem
					key={`${prop.title}-${index}`}
					icon={prop.icon}
					title={prop.title}
					subtitle={prop.subtitle}
				/>
			))}
		</Box>
	);
};

export default FeatureList;
